import { render, staticRenderFns } from "./form-modal.vue?vue&type=template&id=2a638b5d&lang=pug&"
import script from "./form-modal.vue?vue&type=script&lang=js&"
export * from "./form-modal.vue?vue&type=script&lang=js&"
import style0 from "./form-modal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports